import { createAsyncThunk } from "@reduxjs/toolkit";
import AxiosClient from "src/utils/axiosConfig";

export const getEventWebAsync = createAsyncThunk('event/getEventAsync', async (params, toolkit) =>
  AxiosClient({
    toolkit,
    url: 'event/web',
    method: 'post',
    params,
  })
);